module.exports = __webpack_public_path__ + "static/media/schwangerschaft-desktop.053349fe.jpg";